import { isDefined } from "@/utils/utils";
import { Card, Checkbox, Flex } from "antd";
import { useMemo } from "react";
import type { UUID } from "../../../../../typings/global";
import { resolveInstitutionLogo } from "../../../../institution/utils";
import type { CalcResult, CalcResultData } from "../../types";
import { groupByInstitution, sortResultGroupsByInstitutionName } from "../../utils";

type Props<T extends CalcResultData> = {
  results: CalcResult<T>[];
  excludedInstitutionIds: UUID[];
  onChange: (excludedInstitutionIds: UUID[]) => void;
};

export const CalcResultInstitutionsFilter = <T extends CalcResultData>({
  results,
  excludedInstitutionIds,
  onChange,
}: Props<T>) => {
  const institutions = useMemo(
    () =>
      sortResultGroupsByInstitutionName(groupByInstitution(results.filter((result) => !result.error)))
        .map((group) => group[0]?.insuranceInstitution)
        .filter(isDefined),
    [results],
  );

  const institutionIds = institutions.map((institution) => institution.id);
  const selectedInstitutionIds = institutionIds.filter((id) => !excludedInstitutionIds.includes(id));

  return (
    <Checkbox.Group<UUID>
      value={selectedInstitutionIds}
      onChange={(checkedIds) => onChange(institutionIds.filter((id) => !checkedIds.includes(id)))}
      style={{ width: "100%" }}
    >
      <Flex wrap gap="small">
        {institutions.map((institution) => (
          <Card key={institution.id} size="small">
            <Checkbox value={institution.id} style={{ alignItems: "center" }}>
              <Flex align="center" gap="small">
                <img
                  width="40"
                  height="20"
                  style={{ objectFit: "contain" }}
                  src={resolveInstitutionLogo(institution)}
                  alt=""
                />
                {institution.name}
              </Flex>
            </Checkbox>
          </Card>
        ))}
      </Flex>
    </Checkbox.Group>
  );
};
